// "To do", "In progress", "Done"

export const categoriesArray = ['to-do', 'in-progress', 'done'];

export const category = {
  toDo: 'to-do',
  inProgress: 'in-progress',
  done: 'done',
};
